import * as React from "react";
import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHamburger = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 15 15",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M1.5 3a.5.5 0 0 0 0 1h12a.5.5 0 0 0 0-1zM1 7.5a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 0 1h-12a.5.5 0 0 1-.5-.5m0 4a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 0 1h-12a.5.5 0 0 1-.5-.5",
		clipRule: "evenodd"
	})
});
const Memo = memo(SvgHamburger);
export default Memo;
